import { UpdateSfpSkippedAllMeta, UpdateSfpSkippedAllPayload } from 'types/store/UpdateSfpSkippedAll';
import { createAsyncReducer } from 'utils/Redux';

import { updateSfpSkippedAllActions } from '../actions';

export default createAsyncReducer<UpdateSfpSkippedAllMeta, UpdateSfpSkippedAllPayload>(updateSfpSkippedAllActions);
